import React, { Component } from "react";

export default class CarImage extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {}
  componentDidUpdate(prevProps, prevState) {}
  setIsLoaded = () => {
    this.setState({
      isloaded: true,
    });
  };
  render() {
    const { data } = this.props;

    return (
      <>
        <div className="carImage">
          <img className="currentImage" alt={data.kirjeldus} src={data.img} />
          {/*
          this.props.prevCarImage && this.props.prevCarImage.img && 
          <img
            className={`prevImage ${isloaded ? "hide" : "show"}`}
            alt={data.kirjeldus}
            src={this.props.prevCarImage.img}
          />*/}
          <img className="blurred" alt={data.kirjeldus} src={data.img} />
        </div>
        {data.staatus === "Laos" && (
          <img className="badge" src="./assets/images/laos.svg" alt="laos" />
        )}
      </>
    );
  }
}
